import React, { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { useNavigate } from 'react-router-dom';

// Per IONOS: l'API PHP està al mateix domini
const getApiBase = () => {
  if (process.env.NODE_ENV === 'production') {
    return '';  // Mateix domini
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

const Portfolio = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('video');
  const [projects, setProjects] = useState({
    video: [],
    photography: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const apiBase = getApiBase();
      const response = await fetch(`${apiBase}/api/projects/index.php`);
      if (response.ok) {
        const data = await response.json();
        const videoProjs = data.filter(p => p.type === 'video');
        const photoProjs = data.filter(p => p.type === 'photography');
        
        setProjects({
          video: videoProjs,
          photography: photoProjs
        });
      }
    } catch (error) {
      console.error('Error fetching projects:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleProjectClick = (projectId) => {
    navigate(`/project/${projectId}`);
  };

  const ProjectCard = ({ project }) => (
    <div 
      className="project-card group relative overflow-hidden rounded-lg shadow-xl"
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img 
          src={project.thumbnail_url || project.thumbnail}
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-300"></div>
      
      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
        <p className="text-sm uppercase tracking-wider text-gray-300 mb-2">{project.category}</p>
        <h3 className="text-2xl font-bold mb-2">{project.title}</h3>
        <p className="text-sm text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300 line-clamp-2">
          {project.description}
        </p>
        <p className="text-xs text-gray-400 mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          {project.year || project.date}
        </p>
      </div>
    </div>
  );

  return (
    <section id="portfolio" className="portfolio-section py-32 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Portfolio
          </h2>
          <div className="h-1 w-24 bg-white mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Explora mis trabajos en producción de vídeo y fotografía
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-16 bg-white/5 backdrop-blur-sm p-1 rounded-lg">
            <TabsTrigger 
              value="video"
              className="data-[state=active]:bg-white data-[state=active]:text-black text-white transition-all duration-300"
            >
              Proyectos de Vídeo
            </TabsTrigger>
            <TabsTrigger 
              value="photography"
              className="data-[state=active]:bg-white data-[state=active]:text-black text-white transition-all duration-300"
            >
              Fotografía
            </TabsTrigger>
          </TabsList>

          <TabsContent value="video" className="mt-0">
            {loading ? (
              <div className="text-center text-gray-400">Cargando proyectos...</div>
            ) : projects.video.length === 0 ? (
              <div className="text-center text-gray-400">Aún no hay proyectos de vídeo</div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {projects.video.map((project) => (
                  <ProjectCard key={project.id} project={project} />
                ))}
              </div>
            )}
          </TabsContent>

          <TabsContent value="photography" className="mt-0">
            {loading ? (
              <div className="text-center text-gray-400">Cargando proyectos...</div>
            ) : projects.photography.length === 0 ? (
              <div className="text-center text-gray-400">Aún no hay proyectos de fotografía</div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {projects.photography.map((project) => (
                  <ProjectCard key={project.id} project={project} />
                ))}
              </div>
            )}
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default Portfolio;
